import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatDividerModule } from '@angular/material/divider'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { FeedsBellModule } from './feeds-bell/feeds-bell.module'
import { HeaderComponent } from './header.component'
import { LogoModule } from './logo/logo.module'
import { PasswordFormModule } from './password-form/password-form.module'

@NgModule({
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatDividerModule,
    MatMenuModule,
    MatTooltipModule,
    FlexLayoutModule,
    FeedsBellModule,
    LogoModule,
    PasswordFormModule,
  ],
})
export class HeaderModule {}
